import React, { useState } from "react";

export const mono = { fontFamily: "'JetBrains Mono',monospace" };

export function Divider() {
  return <div style={{ height:1, background:"#06111e", margin:"8px 0" }}/>;
}

export function SectionHead({ children, color="#2a3a4a" }) {
  return (
    <div style={{ fontSize:8.5, fontWeight:800, letterSpacing:2,
      color, padding:"6px 12px 3px", ...mono }}>
      {children}
    </div>
  );
}

export function Row({ label, children }) {
  return (
    <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center",
      padding:"3px 12px", minHeight:22 }}>
      <span style={{ fontSize:10, color:"#2a3a4a", ...mono }}>{label}</span>
      <span style={{ fontSize:10, color:"#6b7e94", textAlign:"right", ...mono }}>{children}</span>
    </div>
  );
}

export function EditRow({ label, value, onCommit, suffix="", type="text", min, max, step }) {
  const [editing, setEditing] = useState(false);
  const [draft,   setDraft]   = useState(String(value));
  const commit = () => {
    const v = type==="number" ? Number(draft) : draft;
    if (type==="number" && (isNaN(v)||(min!=null&&v<min)||(max!=null&&v>max))) {
      setDraft(String(value)); setEditing(false); return;
    }
    onCommit(v); setEditing(false);
  };
  if (!editing) return (
    <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center",
      padding:"3px 12px", minHeight:22, cursor:"text" }}
      onDoubleClick={() => { setDraft(String(value)); setEditing(true); }}>
      <span style={{ fontSize:10, color:"#2a3a4a", ...mono }}>{label}</span>
      <span style={{ fontSize:10, color:"#60a5fa", ...mono }} title="Double-click to edit">
        {value}{suffix}
      </span>
    </div>
  );
  return (
    <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center",
      padding:"3px 12px", minHeight:22 }}>
      <span style={{ fontSize:10, color:"#2a3a4a", ...mono }}>{label}</span>
      <input autoFocus value={draft} type={type} min={min} max={max} step={step}
        onChange={e => setDraft(e.target.value)}
        onBlur={commit}
        onKeyDown={e => { if(e.key==="Enter") commit(); if(e.key==="Escape"){setDraft(String(value));setEditing(false);} }}
        style={{ width:90, background:"#06111e", border:"1px solid #3b82f6",
          color:"#60a5fa", borderRadius:3, padding:"1px 6px",
          fontSize:10, ...mono, outline:"none", textAlign:"right" }}/>
    </div>
  );
}
